import { render, staticRenderFns } from "./CoinIcon.vue?vue&type=template&id=5a915150&"
import script from "./CoinIcon.vue?vue&type=script&lang=js&"
export * from "./CoinIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports